// User Model
import { Model } from '@vuex-orm/core';

export default class LiveRoom extends Model {
    // This is the name used as module name of the Vuex Store.
    static entity = 'liverooms'

    // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    static fields() {
        return {
            id: this.attr(null),
            sid: this.attr(null),
            name: this.attr(''),
            status: this.attr('PLANNED'),
            empty_timeout: this.attr(null),
            max_participants: this.attr(null),
            max_hosts: this.attr(null),
            active_recording: this.attr(false),
            participants: this.attr([]),
            created_at: this.attr(''),
            updated_at: this.attr(''),

            //TODO: consider to move this to LiveRoomParticipant Model
            local_camera_is_muted: this.attr(true),
            local_microphone_is_muted: this.attr(true),
            local_screen_is_muted: this.attr(true),

            tracks_subscribed: this.attr([]),
            screen_sharer: this.attr(null),
            presence_channel: this.attr(null),
            // So the value of a range input is a DOMString, that's why we use a string throughout this component instead of a number.
            // Could cast everything but thought it was a better idea to just go with the HTML specs.
            // Value should lie be between 0 and 100
            volume: this.attr('50'),
        };
    }

    static apiConfig = {
        actions: {},
    }
}

window.LiveRoom = LiveRoom;
